export default __webpack_public_path__ + "static/media/empty_cart.49678c0f.gif";